import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { TNMClassLineComponent } from '../tnmclass-line/tnmclass-line.component';
import { MatDialog } from '@angular/material/dialog';
import { DatabankModel } from 'src/app/models/DataBankModel';

@Component({
  selector: 'app-tnmclass',
  templateUrl: './tnmclass.component.html',
  styleUrls: ['./tnmclass.component.css']
})
export class TNMClassComponent implements OnInit {
  digdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  wk_Family = "Cancer lung";
  Wk_T = '1'
  Wk_N = '0'
  Wk_M = '2'
  constructor(private dialogref: MatDialog,
    public stores : DatabankModel
  ) { }

  ngOnInit(): void {
  }
  openDialog(){
    const dialogRef = this.dialogref.open(TNMClassLineComponent,
      {
        data: {
          dataKey: this.stores
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        dialogSubmitSubscription.unsubscribe();
      });
  }
}
